const Input = {
  // Styles for the base style
  baseStyle: {
    bg: 'secondary.InputGray'
  },
  // Styles for the size variations
  sizes: {},
  // Styles for the visual style variations
  variants: {},
  // The default `size` or `variant` values
  defaultProps: {
    variant: 'filled',
    focusBorderColor: 'primary.Purple',
    errorBorderColor: 'state.Error'
  },
}

export default Input